import request from '@/config/request';
import API from '@/config/domain';

export default {
  // 列表
  pageAppManageInfo(params, callback) {
    return request(API.BASEAPI + 'rest/appManageInfo/pageAppManageInfo', 'post', params).then((data) => {
      callback(data);
    })
  },
  // 应用管理-保存
  saveAppManageInfo(params, callback) {
    return request(API.BASEAPI + 'rest/appManageInfo/saveAppManageInfo', 'post', params).then((data) => {
      callback(data);
    })
  },
  // 应用管理-详情接口
  getAppManageInfo(params, callback) {
    return request(API.BASEAPI + 'rest/appManageInfo/getAppManageInfo', 'post', params).then((data) => {
      callback(data);
    })
  },
  // 应用管理-删除接口
  deleteAppManageInfo(params, callback) {
    return request(API.BASEAPI + 'rest/appManageInfo/deleteAppManageInfo', 'post', params).then((data) => {
      callback(data);
    })
  },
};